<!-- Training Type -->

<app-admin-header
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
></app-admin-header>
<div class="container-fluid">
  <div [hidden]="skeleton" class="row custom-margin">
    <div class="col-12 p-0">
      <app-no-data *ngIf="data.length == 0 && !skeleton"></app-no-data>
      <div class="container mb-4">
        <app-table
          [unit]="'TRAINING_TYPE'"
          *ngIf="data.length > 0"
          [data]="data"
          (actionCall)="actionCall($event)"
        ></app-table>
      </div>
    </div>

    <div
      class="col-12 p-0"
      *ngIf="permissionService.hasPermission('TRAINING_TYPE', 'c')"
    >
      <div class="container mb-5">
        <h2 class="text-center v4-color-white">
          <i
            style="font-size: 2rem"
            class="pi pi-fw pi-plus-circle mx-2 v4-color-white"
          ></i
          >{{ "Add a new type" | translator }}
        </h2>
        <app-dynamic-form
          [questions]="questions"
          (sendData)="receiveData($event)"
        ></app-dynamic-form>
        <p-messages [(value)]="messages" [enableService]="false"></p-messages>
      </div>
    </div>
  </div>
</div>
<!-- skeleton   -->
<app-skelitions [hidden]="!skeleton" [value]="1" class="mb-2"></app-skelitions>

<!-- Confirm Modal -->
<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

<!-- Update Data Modal -->
<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="Header"
  [(visible)]="updateModal"
  [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1200px' }"
>
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "Update type" | translator }}</span>
  </ng-template>
  <app-dynamic-form
    *ngIf="updateModal"
    [questions]="updateQuestions"
    (sendData)="UpdateData($event)"
  ></app-dynamic-form>
</p-dialog>

<app-footer></app-footer>
